<template>
  <div :style="{ height: height + 'px' }"></div>
</template>
<script>
export default {
  name: "EmptyInterlayer",
  data() {
    return {
      countDown: "",
      hander: {
        timer: null,
        interval: null
      }
    };
  },
  props: {
    height: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
</style>